import React from 'react';

export default () => (
  <svg width="80" height="68" viewBox="0 0 80 68" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M52.7442 68L37.8603 53.1294L40.822 50.1704L52.7442 62.0819L76.5383 38.309L79.5 41.2639L52.7442 68ZM38.1489 25.0768L70.3262 4.17947H5.97164L38.1489 25.0768ZM38.1489 29.7411L4.68321 7.8783V51.7628C4.68321 52.5123 4.92445 53.128 5.40691 53.6101C5.88937 54.0921 6.5071 54.3331 7.26008 54.3331H27.2726L31.4558 58.5126H7.26008C5.33301 58.5126 3.72526 57.869 2.43683 56.5817C1.1484 55.2944 0.502789 53.6867 0.5 51.7586V6.75403C0.5 4.82868 1.14561 3.22237 2.43683 1.93509C3.72805 0.647817 5.3344 0.00278631 7.25589 0H69.042C70.9662 0 72.5726 0.645031 73.861 1.93509C75.1495 3.22516 75.7951 4.83147 75.7979 6.75403V27.3421L71.6146 31.5216V7.8783L38.1489 29.7411Z" 
      // fill="currentColor"
    />
  </svg>
)


